import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';
import configureStore from './store/configure';

import RoyaltySettings from './royalty_settings';
import { convertedScheduleTiers } from 'bundles/backoffice/helpers/royalties';

export default class RoyaltySettingsIndex extends React.Component {
  static propTypes = {
    allowPropertyManagementDeals: PropTypes.bool,
    alternateRoyaltyEnabled: PropTypes.bool,
    alternateRoyaltyPercent: PropTypes.number,
    alternateRoyaltyTotal: PropTypes.number,
    defaultRoyaltyPatterns: PropTypes.object,
    isParentCompanyUser: PropTypes.bool,
    labelsByRoyaltyPatternName: PropTypes.object.isRequired,
    paths: PropTypes.object,
    propertyManagementRoyaltyPercent: PropTypes.number,
    propertyManagementTotal: PropTypes.number,
    royaltySchedules: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.store = configureStore({
      alternateRoyalty: {
        enabled: this.props.alternateRoyaltyEnabled,
        errors: [],
        grossCommissionTotal: this.props.alternateRoyaltyTotal,
        royaltyPercent: this.props.alternateRoyaltyPercent,
      },
      isParentCompanyUser: this.props.isParentCompanyUser,
      paths: { ...this.props.paths },
      propertyManagement: {
        allowDeals: this.props.allowPropertyManagementDeals,
        grossCommissionTotal: this.props.propertyManagementTotal,
        royaltyPercent: this.props.propertyManagementRoyaltyPercent,
      },
      royaltySchedules: {
        defaultRoyaltyPatterns: this.props.defaultRoyaltyPatterns,
        errors: [],
        labelsByRoyaltyPatternName: this.props.labelsByRoyaltyPatternName,
        schedules: this.props.royaltySchedules.map(schedule => ({
          ...schedule,
          tiers: convertedScheduleTiers(schedule, this.props.defaultRoyaltyPatterns),
        })),
      },
    });
  }

  render() {
    return (
      <Provider store={this.store}>
        <RoyaltySettings />
      </Provider>
    );
  }
}
